/**
 * @generated SignedSource<<a6376b6cbc3f92af8c28358d0e92fbf4>>
 * @relayHash 832d05bec49a8a1714125484b3ae0a06
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9e0defefded0c0e2cc7999fe003d5a70f1478a2fc10df9b20578748e3ac5c245

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { CustomerDetailsCustomerDetailsPageQuery } from './CustomerDetailsCustomerDetailsPageQuery.graphql';

import isAssetsFieldEnabled_provider from '@jira/platform__graphql-relay-provider/src/csmNativeAssetsFieldCustomerContextRelayprovider';
import isAssetsFastFollowEnabled_provider from '@jira/platform__graphql-relay-provider/src/csmNativeAssetsFieldCustomerCtxFastFollowsRelayprovider';

const node: PreloadableConcreteRequest<CustomerDetailsCustomerDetailsPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "9e0defefded0c0e2cc7999fe003d5a70f1478a2fc10df9b20578748e3ac5c245",
    "metadata": {},
    "name": "CustomerDetailsCustomerDetailsPageQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrccsmNativeAssetsFieldCustomerContextRelayprovidertsx": isAssetsFieldEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrccsmNativeAssetsFieldCustomerCtxFastFollowsRelayprovidertsx": isAssetsFastFollowEnabled_provider
    }
  }
};

export default node;
